import { launchDeerAppAPI } from '../apis';

type LaunchAppProps = {
  operationType: string;
  sendEmail?: boolean;
};

export const launchDeerApp = async ({ operationType, sendEmail }: LaunchAppProps) => {
  try {
    const res = await launchDeerAppAPI({
      operationType,
      sendEmail,
    });

    const data = res.entity;

    return data;
  } catch (error) {
    console.error('Error while launching the new UX:', error);
    throw new Error(error.message);
  }
};
